import { NEXT_PUBLIC_API_HOST_NAME, NEXT_PUBLIC_SSR_API_HOST_NAME } from "@/libs/constants/auth";
import { isBrowser } from "@/libs/helpers";

export const apiHostBaseUri = () => (isBrowser() ? NEXT_PUBLIC_API_HOST_NAME : NEXT_PUBLIC_SSR_API_HOST_NAME);
